

































































import VueOptions from '@utils/VueOptions'
import WizardNavbar from '@ui/SpaceWizards/OnsiteSpaceWizard/WizardNavbar'
import WizardNavigation from '@ui/SpaceWizards/OnsiteSpaceWizard/WizardNavigation'

settings =
  name: 'SpaceOverviewStep'

  vue:
    props: ['wizard', 'step']

    components: {
      WizardNavbar,
      WizardNavigation,
    }

    data: ->
      form: @wizard.spaceData()

    computed:
      canEditInventoryType: -> !@$route.name.toLowerCase().includes 'edit'

      imagesForSamplingActivation: ->
        image = @imageFor 'spaces', 'activation-example-sampling-1.png'
        [image]

      imagesForOnsiteSpaceActivation: ->
        image = @imageFor 'spaces', 'activation-example-onsite-space-1.jpg'
        [image]

export default VueOptions.vue settings
